import React from "react";
import "./Button.scss";

const Button = ({
  children, // Text or elements inside the button
  variant = "primary", // Style variant: 'primary', 'secondary', etc.
  size = "md", // Size of the button: 'sm', 'md', 'lg', etc.
  widthSize, // width size of the button: 'sm', 'md', 'full', etc.
  disabled = false, // Disable state of the button
  className = "", // Additional custom class names
  ...props // Other button props (e.g., onClick, type)
}) => {
  const classes = `button borderInner ${variant} ${size}  ${
    disabled ? "disabled" : ""
  }`; //  class for the button element

  const prenetClasses = `borderWrapper button-parent ${className} ${widthSize} ${
    disabled ? "disabled" : ""
  }`; //  class for the outer wrapper div

  return (
    <div className={prenetClasses}>
      <button className={classes} disabled={disabled} {...props}>
        {children}
      </button>
    </div>
  );
};

export default Button;
